const homepage = {
    title: 'Accueil',
    description: '',
}

export default homepage
